var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginStepIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2593_8091)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1176 0C18.2618 0 20 1.73819 20 3.88236V11.8863C20 13.3568 19.1692 14.7011 17.8539 15.3588L0 24.2857V3.88235C0 1.73819 1.73819 0 3.88235 0H16.1176ZM4.28569 5.71411H15.7143V8.57125H4.28569V5.71411Z",
    fill: "#FD757A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88235 0C1.73819 0 0 1.73819 0 3.88236V11.8863C0 13.3568 0.830835 14.7011 2.14611 15.3588L20 24.2857V3.88235C20 1.73819 18.2618 0 16.1176 0H3.88235ZM15.7142 5.71411H4.28558V8.57125H15.7142V5.71411Z",
    fill: "#DE0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2593_8091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginStepIcon);
export default __webpack_public_path__ + "static/media/login_step_icon.d8db482ed14c1f43f58c395b2b0c6d9f.svg";
export { ForwardRef as ReactComponent };